import {
  JOB_COUNT,
  JOB_COUNT_SUCCESSFUL,
  JOB_COUNT_FAILED,
  JOB_SEARCH_COUNT,
} from "./actionTypes"

const initialState = {
  jobCountError: null,
  message: null,
  loading: false,
  user: null,
}

const getJobCount = (state = initialState, action) => {
  switch (action.type) {
    case JOB_COUNT:
      state = {
        ...state,
        loading: true,
        jobCountError: null,
      }
      break
    case JOB_COUNT_SUCCESSFUL:
      state = {
        ...state,
        loading: false,
        user: action.payload,
        jobCountError: null,
      }
      break
    case JOB_COUNT_FAILED:
     
      state = {
        ...state,
        user: null,
        loading: false,
        jobCountError: action.payload,
      }
      break
      case JOB_SEARCH_COUNT:
      state = {
        ...state,
        loading: true,
        jobCountError: null,
      }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default getJobCount
